// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"8a0a9543","651":"13109c10","667":"cb301e41","761":"cf40db3f","977":"e231e8da"}[chunkId] + ".chunk.js");